import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { selectActivePage } from '../features/ui/uiSlice'
import { selectEventsData, setEventData } from '../features/events/eventsSlice';
import { useTranslation } from 'react-i18next';
import { setRole } from '../features/track/infoSlice';
import { sendAnalyticsEvents } from '../analytics/common';
import { EVENTS } from '../analytics/events';
import {useHistory} from 'react-router-dom'
import { selectLandingType } from '../features/plans/plansSlice';

const StyledBarWrapper = styled.div`
  height: 8px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;

  @media screen and (min-width: 450px) {
    margin-top: 4vh;
    margin-bottom: 4vh;
  }
`;

const StyledBar = styled.div`
  min-height: 8px;
  width: 284px;
  height: 100%;
  display: flex;
`;

const SkipBtn = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: #323232;
  margin-left: 26px;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

const StyledBarItem = styled.div`
    flex-grow: 1;
    background-color: ${({ isActive }) =>
    isActive
      ? '#F58A3C'
      : '#F3F3F3'};
    transition: background-color 300ms;
    :first-child {
        border-top-left-radius: 29px;
        border-bottom-left-radius: 29px;
    }
    :last-child {
        border-top-right-radius: 29px;
        border-bottom-right-radius: 29px;
    }
`;

const ProgrBar = () => {
    const activePage = useSelector(selectActivePage);
    const [showBar,setShowBar] = useState(false);
    const dispatch = useDispatch();
    const eventsData = useSelector(selectEventsData);
    const { t } = useTranslation();
    const history = useHistory();
    const landingType = useSelector(selectLandingType);
    const isIntroOffer = landingType === 'intro_offer';
  
    const pagesWithProgressBar = useMemo(() => {
        return [
            'choose-target',
            "choose-location",
            "choose-reason",
            "choose-time",
            "choose-frequency",
            "choose-location-type",
            "choose-quantity",
            "choose-feature",
            "explore-solutions",
            'real-time-location',
            'place-alerts',
            'check-in',
            'location-history',
            'panic-button',
            'platform-support',
            !isIntroOffer && 'signup',
        ]
    },[isIntroOffer]);

    const activePageIndex = useMemo(() => pagesWithProgressBar.indexOf(activePage), [activePage, pagesWithProgressBar]);

    useEffect(() => {
        setShowBar(activePageIndex >= 0);
    }, [activePageIndex]);

    const renderProgress = (item,i) => {
        const isActive = (i <= activePageIndex);

        return <StyledBarItem isActive={isActive} key={i}/>
    };

    if (!showBar) return null;

    const pageTransitions = {
        "choose-target": {
          eventId: "onboardingRoleSkip",
          eventDataKey: "Role",
          nextPage: "/choose-location",
          setupRole: true
        },
        "choose-location": {
          eventId: "onboardingLocationsSkip",
          eventDataKey: "Locations",
          nextPage: "/choose-reason",
        },
        "choose-reason": {
          eventId: "onboardingReasonSkip",
          eventDataKey: "Reason",
          nextPage: "/choose-time",
        },
        "choose-time": {
          eventId: "onboardingCheckTimeSkip",
          eventDataKey: "Frequency",
          nextPage: "/choose-frequency",
        },
        "choose-frequency": {
          eventId: "onboardingUpdatesSkip",
          eventDataKey: "Updates",
          nextPage: "/choose-location-type",
        },
        "choose-location-type": {
          eventId: "onboardingInappropriateSkip",
          eventDataKey: "InappropriateGeos",
          nextPage: "/choose-quantity",
        },
        "choose-quantity": {
          eventId: "onboardingQuantitySkip",
          eventDataKey: "Quantity",
          nextPage: "/choose-feature",
        },
        "choose-feature": {
          eventId: "onboardingFeatureListSkip",
          eventDataKey: "Features",
          nextPage: "/explore-solutions",
        },
      };
      
      const handleSkipClick = () => {
        const pageTransition = pageTransitions[activePage];
      
        if (pageTransition) {
          const { eventId, eventDataKey, nextPage, setupRole } = pageTransition;
      
          dispatch(setEventData({ id: eventDataKey, data: 'Other' }));
          setupRole && dispatch(setRole('Other'));
          const updatedEventData = {
            ...eventsData,
            [eventDataKey]: 'Other',
          };
      
          sendAnalyticsEvents(EVENTS[eventId], updatedEventData);
          history.push(nextPage);
        }
      };

    return (<StyledBarWrapper>
    <StyledBar>{pagesWithProgressBar.map(renderProgress)}</StyledBar>
    {pageTransitions[activePage] && <SkipBtn id='skip-button' onClick={() => handleSkipClick()}>{t('skip')}</SkipBtn>}
  </StyledBarWrapper>)
};

export default ProgrBar
